/**
 * BaseInvitation.styles
 * Shared styles for pending invitation cards (friends and groups)
 * Used by PendingInvitationCard and FriendCardPending
 */

import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getBaseInvitationStyles = (theme: Theme) =>
  StyleSheet.create({
    receivedInvitationContainer: {
      flex: 1,
      minHeight: 0,
      padding: 16,
      paddingTop: 20,
      paddingBottom: 20,
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    inviterNameText: {
      color: theme.black,
      fontSize: 16,
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: 4,
      paddingHorizontal: 8,
    },
    invitationMessage: {
      color: theme.gray[600],
      fontSize: 14,
      textAlign: 'center',
      marginBottom: 12,
    },
    actionRow: {
      flexDirection: 'row',
      gap: 8,
      width: '100%',
    },
    acceptButton: {
      flex: 1,
      backgroundColor: theme.success,
      paddingHorizontal: 12,
      paddingVertical: 10,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 40,
      flexDirection: 'row',
      shadowColor: theme.success,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.2,
      shadowRadius: 4,
      elevation: 3,
    },
    acceptButtonText: {
      color: theme.textOnStatusBadge,
      fontSize: 13,
      fontWeight: '700',
    },
    acceptButtonPressed: { opacity: 0.8 },
    acceptButtonHover: { opacity: 0.9 },
    declineButton: {
      flex: 1,
      backgroundColor: theme.background.card,
      paddingHorizontal: 12,
      paddingVertical: 10,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 40,
      flexDirection: 'row',
      borderWidth: 2,
      borderColor: theme.gray[300],
    },
    declineButtonText: {
      color: theme.gray[700],
      fontSize: 13,
      fontWeight: '700',
    },
    declineButtonPressed: { opacity: 0.8 },
    declineButtonHover: { opacity: 0.9 },
    buttonIcon: {
      marginRight: 4,
    },
    buttonDisabled: {
      opacity: 0.5,
    },
    sentInvitationContainer: {
      flex: 1,
      minHeight: 0,
      padding: 16,
      paddingTop: 20,
      paddingBottom: 20,
      alignItems: 'center',
      position: 'relative',
      justifyContent: 'center',
    },
    pendingRemoveButton: {
      position: 'absolute',
      top: 8,
      right: 8,
      padding: 6,
      zIndex: 10,
    },
    pendingRemoveButtonPressed: { opacity: 0.7 },
    pendingRemoveButtonHover: { opacity: 0.9 },
    pendingContent: {
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center',
      flex: 1,
    },
    waitingIcon: {
      marginBottom: 8,
    },
    waitingText: {
      color: theme.black,
      fontSize: 16,
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: 4,
      paddingHorizontal: 8,
    },
    pendingStatusText: {
      color: theme.gray[600],
      fontSize: 12,
      textAlign: 'center',
      fontWeight: '500',
      marginBottom: 4,
    },
    invitedEmailText: {
      color: theme.gray[500],
      fontSize: 12,
      textAlign: 'center',
      marginBottom: 16,
    },
    errorText: {
      color: theme.error,
      fontSize: 14,
      textAlign: 'center',
    },
  });
